import React from "react";
import { useRecordContext } from "react-admin";

const UserTitle = () => {
	const record = useRecordContext();
	return <span>{record ? `"${record.full_name}"` : ""}</span>;
};

export default UserTitle;
